/* ==========================================================================
   TestHelden v2 · Footer + Newsletter · assets/th-v2-footer.js
   1. Footer-Akkordeon unter 768 px (aria-expanded + hidden; ab 768 px ist der Schalter per CSS ausgeblendet,
      die Listen sind offen). Ohne JS bleiben alle Listen offen. Portiert aus designsystem/system/js/navigation.js §5.
   2. Newsletter: Prüfung der E-Mail vor dem Absenden (Fehler 14 px unter dem Feld, aria-invalid, Fokus ins Feld),
      Lade-Zustand des Knopfs, nach erfolgreichem Absenden Fokus auf die Statusmeldung.
   3. „Cookie-Einstellungen“: erscheint nur, wenn der Shopify-Cookie-Banner da ist (window.privacyBanner), und öffnet
      dessen Einstellungen (privacyBanner.showPreferences, Customer Privacy API).
   Vanilla JS, idempotent, Theme-Editor: shopify:section:load.
   ========================================================================== */
(function (window, document) {
  'use strict';
  if (window.thV2Footer) { return; }

  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var mobil = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

  function einmal(el, key) {
    key = '__thV2F' + key;
    if (el[key]) { return false; }
    el[key] = true;
    return true;
  }

  /* ---------- 1. Akkordeon ---------- */
  function initAkkordeon(root) {
    qsa('[data-th-v2-footer]', root).forEach(function (footer) {
      if (!einmal(footer, 'Akk')) { return; }
      var toggles = qsa('[data-th-v2-footer-toggle]', footer);
      function liste(t) {
        var id = t.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
      }
      function setze(istMobil) {
        toggles.forEach(function (t) {
          var l = liste(t);
          if (!l) { return; }
          t.setAttribute('aria-expanded', istMobil ? 'false' : 'true');
          l.hidden = istMobil;
        });
      }
      toggles.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!mobil.matches) { return; }
          var l = liste(t);
          if (!l) { return; }
          var offen = t.getAttribute('aria-expanded') === 'true';
          t.setAttribute('aria-expanded', offen ? 'false' : 'true');
          l.hidden = offen;
        });
      });
      setze(mobil.matches);
      var aufWechsel = function (e) { setze(e.matches); };
      if (mobil.addEventListener) { mobil.addEventListener('change', aufWechsel); }
      else if (mobil.addListener) { mobil.addListener(aufWechsel); }
    });
  }

  /* ---------- 2. Newsletter ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function initNewsletter(root) {
    qsa('[data-th-v2-newsletter]', root).forEach(function (band) {
      if (!einmal(band, 'Nl')) { return; }
      var status = band.querySelector('[data-th-v2-nl-status]');
      if (status && window.location.search.indexOf('customer_posted=true') !== -1) {
        status.focus();
      }
      var form = band.querySelector('form');
      var feld = band.querySelector('[data-th-v2-nl-email]');
      var fehler = band.querySelector('[data-th-v2-nl-fehler]');
      var fehlerText = band.querySelector('[data-th-v2-nl-fehlertext]');
      if (!form || !feld || !fehler || !fehlerText) { return; }
      var knopf = form.querySelector('[type="submit"]');
      var huelle = feld.closest('.th-field');

      function zeigeFehler(text) {
        fehlerText.textContent = text;
        fehler.hidden = false;
        feld.setAttribute('aria-invalid', 'true');
        feld.setAttribute('aria-describedby', fehler.id);
        if (huelle) { huelle.classList.add('is-invalid'); }
      }
      function loescheFehler() {
        fehler.hidden = true;
        feld.removeAttribute('aria-invalid');
        feld.removeAttribute('aria-describedby');
        if (huelle) { huelle.classList.remove('is-invalid'); }
      }

      form.addEventListener('submit', function (ev) {
        var wert = (feld.value || '').trim();
        feld.value = wert;
        if (!wert) {
          ev.preventDefault();
          zeigeFehler(feld.getAttribute('data-msg-leer') || '');
          feld.focus();
          return;
        }
        if (!EMAIL.test(wert)) {
          ev.preventDefault();
          zeigeFehler(feld.getAttribute('data-msg-format') || '');
          feld.focus();
          return;
        }
        loescheFehler();
        if (knopf) {
          knopf.classList.add('is-loading');
          knopf.setAttribute('aria-busy', 'true');
        }
      });
      feld.addEventListener('input', function () {
        if (feld.getAttribute('aria-invalid') === 'true' && EMAIL.test((feld.value || '').trim())) { loescheFehler(); }
      });
      /* Zurück-Navigation aus dem Cache: Ladezustand zurücksetzen */
      window.addEventListener('pageshow', function () {
        if (knopf) {
          knopf.classList.remove('is-loading');
          knopf.removeAttribute('aria-busy');
        }
      });
    });
  }

  /* ---------- 3. Cookie-Einstellungen ---------- */
  function bannerDa() {
    return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
  }

  function initCookie(root) {
    var eintraege = qsa('[data-th-v2-cookie]', root);
    if (!eintraege.length) { return; }
    eintraege.forEach(function (li) {
      var knopf = li.querySelector('[data-th-v2-cookie-open]');
      if (!knopf || !einmal(knopf, 'Cookie')) { return; }
      knopf.addEventListener('click', function () {
        if (bannerDa()) { window.privacyBanner.showPreferences(); }
      });
    });
    var versuche = 0;
    (function pruefe() {
      if (bannerDa()) {
        eintraege.forEach(function (li) { li.hidden = false; });
        return;
      }
      versuche += 1;
      if (versuche < 20) { window.setTimeout(pruefe, 500); }
    })();
  }

  function init(root) {
    root = root || document;
    initAkkordeon(root);
    initNewsletter(root);
    initCookie(root);
  }

  window.thV2Footer = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})(window, document);
